import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#props">props</a></dt>
      <dd>
        <p>{`props for `}<a parentName="p" {...{
            "href": "#List"
          }}>{`List`}</a></p>
      </dd>
      <dt><a href="#defaultProps">defaultProps</a></dt>
      <dd>
        <p>{`default props for `}<a parentName="p" {...{
            "href": "#List"
          }}>{`List`}</a></p>
      </dd>
    </dl>
    <p>{`The `}<strong parentName="p">{`List`}</strong>{` component maps a collection of data objects into an array of elements.
It also manages the selection and focus of those elements.`}</p>
    <p><strong parentName="p">{`Returns{react.element}`}</strong>{`: A React component that displays list data.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#props"
            }}><inlineCode parentName="a">{`props`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`React Component props`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`props for `}<a parentName="p" {...{
        "href": "#List"
      }}>{`List`}</a></p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`classes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`css classes prop for List`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`classes.root`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`css classes for List root container`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getItemKey`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`func`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`item key value getter`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`initialSelection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`array`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A single or list of objects that should start off selected`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`items`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`iterable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An iterable that yields `}<inlineCode parentName="td">{`[key, item]`}</inlineCode>{` pairs such as an ES2015 Map`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`render`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`func`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A render prop for the list element. A tagname string, such as `}<inlineCode parentName="td">{`"div"`}</inlineCode>{`, is also valid.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`renderItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`func`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A render prop for the list item elements. A tagname string, such as `}<inlineCode parentName="td">{`"div"`}</inlineCode>{`, is also valid`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onSelectionChange`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`func`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback that fires when the selection state changes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selectionModel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`checkbox`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`radio`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A string corresponding to a selection model`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`default props for `}<a parentName="p" {...{
        "href": "#List"
      }}>{`List`}</a></p>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/List/list.js"
      }}>{`pwa-studio/packages/peregrine/lib/List/list.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      